import 'emoji-mart/css/emoji-mart.css';

import { mapHexCodeToEmoticon } from '@assembly-web/services';
import { ChevronDownIcon } from '@heroicons/react/24/outline';
import type { BaseEmoji } from 'emoji-mart';
import { Picker } from 'emoji-mart';
import { useCallback, useState } from 'react';

import { classNames } from '../../../DesignSystem/Utils/classNames';
import { Popover } from '../Popover';

export function EmojiPicker({
  emoji,
  onChange,
  buttonColor,
}: {
  emoji: string;
  onChange: (emoji: string) => void;
  buttonColor: string;
}) {
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);

  const toggleEmojiPicker = () => {
    setShowEmojiPicker(!showEmojiPicker);
  };

  const onEmojiSelect = useCallback(
    (emoji: BaseEmoji) => {
      onChange(emoji.unified);
      setShowEmojiPicker(false);
    },
    [onChange]
  );

  return (
    <div>
      <Popover
        onTriggerButtonClick={toggleEmojiPicker}
        trigger={
          <div
            className={classNames(
              'flex items-center justify-center rounded px-3 py-3 text-[24px] leading-6',
              buttonColor
            )}
          >
            {mapHexCodeToEmoticon(emoji)}
            <ChevronDownIcon className="ml-1 h-4 w-4" />
          </div>
        }
        open={showEmojiPicker}
        onOpenChange={setShowEmojiPicker}
      >
        <Picker onClick={onEmojiSelect} />
      </Popover>
    </div>
  );
}
